export const getErrorMessage = (err, msg = '') => err?.response?.data?.errorMessage || err?.response?.data?.error_message  || msg;

export const getApiFileName = response => {
  const utf8FilenameRegex = /filename\*=UTF-8''([\w%\-\\.]+)(?:; ?|$)/i;
  const asciiFilenameRegex = /^filename=(["']?)(.*?[^\\])\1(?:; ?|$)/i;
  const disposition = response?.headers?.['content-disposition'];

  let fileName = null;
  if (utf8FilenameRegex.test(disposition)) {
    fileName = decodeURIComponent(utf8FilenameRegex.exec(disposition)[1]);
  } else {
    const filenameStart = disposition.toLowerCase().indexOf('filename=');
    if (filenameStart >= 0) {
      const partialDisposition = disposition.slice(filenameStart);
      const matches = asciiFilenameRegex.exec(partialDisposition);
      if (matches != null && matches[2]) {
        fileName = matches[2];
      }
    }
  }
  return fileName;
};

export const getApiQueryParams = ({ params = {}, requiredKeys = [] }) => {
  if (!params) return '';
  if (requiredKeys?.length) {
    const isAccess = requiredKeys.reduce((acc, key) => {
      if (typeof params[key] === undefined) {

        return false;
      }

      return acc;
    }, true);

    if (!isAccess) {
      return '';
    }
  }

  let result = '';
  for (const key in params) {
    const item = params[key];
    if (!result) {
      result = `?${key}=${item}`;
    } else {
      result += `&${key}=${item}`;
    }
  }
  return result;
};
